import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router';
import { useDevice } from 'seagull';
import { useHomePageRoutesByUrl } from '~/hooks/useHomePageRoutesByUrl';
import { useRootDevice } from '~/providers/DeviceProvider';
export function useIsMobileForHomePage() {
    const { isMobileDevice } = useDevice();
    const { isMobileDevice: isMobileDeviceFromRoot } = useRootDevice();
    const location = useLocation();
    const homePagePages = useHomePageRoutesByUrl();
    return useMemo(()=>{
        var _homePagePages_location_pathname;
        if (isMobileDevice) return true;
        if (!isMobileDeviceFromRoot) return false;
        const page = (_homePagePages_location_pathname = homePagePages[location.pathname]) !== null && _homePagePages_location_pathname !== void 0 ? _homePagePages_location_pathname : Object.values(homePagePages).filter((config)=>matchPath(location.pathname, {
                path: config.url
            }) != null).sort((a, b)=>b.url.length - a.url.length)[0];
        if (!(page === null || page === void 0 ? void 0 : page.supportsMobileDevice)) return false;
        return true;
    }, [
        isMobileDevice,
        isMobileDeviceFromRoot,
        homePagePages,
        location.pathname
    ]);
}
